import React from "react"

import Accordion from "components/Accordion"
import AnimatedQuote from "components/AnimatedQuote"
import AsideTestimonial from "components/AsideTestimonial"
import BottomCTA from "components/BottomCTA"
import ByTheNumbers from "components/ByTheNumbers"
import Cards from "components/Cards"
import CenteredContent from "components/CenteredContent"
import ChromeLogoBanner from "components/ChromeLogoBanner"
import CustomerTestimonials from "components/CustomerTestimonials"
import DataCard from "components/DataCard"
import Features from "components/Features"
import G2 from "components/G2Reviews"
import GridComponent from "components/GridComponent"
import G2Banner from "components/G2Banner"
import HighlightedCTA from "components/HighlightedCTA"
import HighlightedCTACard from "components/HighlightedCTACard"
import ImageCTA from "../components/ImageCTA"
import ImgContent from "components/ImgContent"
import InfoBox from "components/InfoBox"
import LogoCube from "components/HP/LogoCube"
import Logos from "components/Logos"
import LongFormText from "components/LongFormText"
import MultiColumn from "components/MultiColumn"
import PartnerStatic from "components/PartnersStatic"
import PillCTA from "components/PillCTA"
import PinScroll from "components/PinScroll"
import ResourceCTA from "components/ResourceCTA"
import SectionHeading from "components/SectionHeading"
import GuidedContent from "components/GuidedContent"
import QaComponent from "components/QaComponent"
import SimpleVideo from "components/SimpleVideo"
import SplitForm from "components/SplitForm"
import StatGrid from "components/StatGrid"
import StyledList from "components/StyledList"
import TableOfContents from "components/TableOfContents"
import Tabs from "components/Tabs"
import Testimonial from "components/Testimonial"
import TestimonialCarousel from "components/TestimonialCarousel"
import ThreeGrid from "components/ThreeGrid"
import TwoColumnList from "components/TwoColumnList"
import SimpleCenteredContent from "components/SimpleCenteredContent"
import ResourceForm from "components/ResourceForm"
import AssetForm from "components/AssetForm"
import AssetHero from "components/AssetHero"
import CodeArea from "components/CodeArea"
import FAQList from "components/FAQList"
import AccordionSplit from "components/AccordionSplit"
import SocialHandles from "components/SocialHandles"
import Overview from "components/Overview/variations/OverviewComponent"
import StatsOverview from "components/Overview/variations/OverviewStats" //delete later
import BoxQuote from "components/Overview/variations/OverviewQuote" //delete later
import OverviewController from "components/Overview/OverviewController"
import MasonryGallery from "../components/MasonryGallery"
import ReviewCTA from "../components/ReviewCTA"
import Card from "../components/Cards/Card"
export const componentToRender = (param, content) => {
  let dynamicParam = param?.replace(/^([^_]*)_.*$/, "$1")

  switch (param) {
    case `${dynamicParam}_Sections_Sections_AssetForm`:
      return <AssetForm content={content} />
    case `${dynamicParam}_Sections_Sections_AssetHero`:
      return <AssetHero content={content} />
    case `${dynamicParam}_Sections_Sections_CodeArea`:
      return <CodeArea content={content} />
    case `${dynamicParam}_Sections_Sections_FaqList`:
      return <FAQList content={content} />
    case `${dynamicParam}_Sections_Sections_SimpleCenteredContent`:
      return <SimpleCenteredContent content={content} />
    case `${dynamicParam}_Sections_Sections_ResourceForm`:
      return <ResourceForm content={content} />
    case `${dynamicParam}_Sections_Sections_AsideTestimonial`:
      return <AsideTestimonial content={content} />
    case `${dynamicParam}_Sections_Sections_Testimonial`:
      return <Testimonial content={content} />
    case `${dynamicParam}_Sections_Sections_ImageContentBlock`:
      return <ImgContent content={content} />
    case `${dynamicParam}_Sections_Sections_GuidedContent`:
      return <GuidedContent content={content} />
    case `${dynamicParam}_Sections_Sections_HighlightedCta`:
      return <HighlightedCTA content={content} />
    case `${dynamicParam}_Sections_Sections_ImageCta`:
      return <ImageCTA content={content} />
    case `${dynamicParam}_Sections_Sections_MultiColumnValueProp`:
      return <MultiColumn content={content} />
    case `${dynamicParam}_Sections_Sections_MultiColumnMutliRowValueProp`:
      return <MultiColumn content={content} />
    case `${dynamicParam}_Sections_Sections_PartnerStatic`:
      return <PartnerStatic content={content} />
    case `${dynamicParam}_Sections_Sections_ThreeGrid`:
      return <ThreeGrid content={content} />
    case `${dynamicParam}_Sections_Sections_StatGrid`:
      return <StatGrid content={content} />
    case `${dynamicParam}_Sections_Sections_AccordionSection`:
      return <Accordion content={content} />
    case `${dynamicParam}_Sections_Sections_ByTheNumbers`:
      return <ByTheNumbers content={content} />
    case `${dynamicParam}_Sections_Sections_SimpleCenteredContent`:
      return <CenteredContent content={content} />
    case `${dynamicParam}_Sections_Sections_SimpleVideo`:
      return <SimpleVideo content={content} />
    case `${dynamicParam}_Sections_Sections_SectionHeading`:
      return <SectionHeading content={content} />
    case `${dynamicParam}_Sections_Sections_CardComponent`:
      return <Cards content={content} />
    case `${dynamicParam}_Sections_Sections_AccordionSplit`:
      return <AccordionSplit content={content} />
    case `${dynamicParam}_Sections_Sections_Tabs`:
      return <Tabs content={content} />
    case `${dynamicParam}_Sections_Sections_GuidedContent`:
      return <GuidedContent content={content} />
    case `${dynamicParam}_Sections_Sections_HighlightedCtaCard`:
      return <HighlightedCTACard content={content} />
    case `${dynamicParam}_Sections_Sections_TableOfContents`:
      return <TableOfContents content={content} />
    case `${dynamicParam}_Sections_Sections_DataCard`:
      return <DataCard content={content} />
    case `${dynamicParam}_Sections_Sections_FlexibleText`:
      return <LongFormText content={content} />
    case `${dynamicParam}_Sections_Sections_LogoCube`:
      return <LogoCube content={content} />
    case `${dynamicParam}_Sections_Sections_G2Ads`:
      return <G2 />
    case `${dynamicParam}_Sections_Sections_QaComponent`:
      return <QaComponent content={content} />
    case `${dynamicParam}_Sections_Sections_G2Banner`:
      return <G2Banner />
    case `${dynamicParam}_Sections_Sections_GridComponent`:
      return <GridComponent content={content} />
    case `${dynamicParam}_Sections_Sections_ChromeLogos`:
      return <ChromeLogoBanner />
    case `${dynamicParam}_Sections_Sections_PinScroll`:
      return <PinScroll content={content} />
    case `${dynamicParam}_Sections_Sections_StyledList`:
      return <StyledList content={content} />
    case `${dynamicParam}_Sections_Sections_SplitForm`:
      return <SplitForm content={content} />
    case `${dynamicParam}_Sections_Sections_PillCta`:
      return <PillCTA content={content} />
    case `${dynamicParam}_Sections_Sections_CustomerTestimonials`:
      return <CustomerTestimonials content={content} />
    case `${dynamicParam}_Sections_Sections_Features`:
      return <Features content={content} />
    case `${dynamicParam}_Sections_Sections_BottomCta`:
      return <BottomCTA content={content} />
    case `${dynamicParam}_Sections_Sections_AnimatedQuote`:
      return <AnimatedQuote content={content} />
    case `${dynamicParam}_Sections_Sections_Logos`:
      return <Logos content={content} />
    case `${dynamicParam}_Sections_Sections_TestimonialCarousel`:
      return <TestimonialCarousel content={content} />
    case `${dynamicParam}_Sections_Sections_InfoBox`:
      return <InfoBox content={content} />
    case `${dynamicParam}_Sections_Sections_TwoColumnList`:
      return <TwoColumnList content={content} />
    case `${dynamicParam}_Sections_Sections_ResourceCta`:
      return <ResourceCTA content={content} />
    case `${dynamicParam}_Sections_Sections_SocialHandles`:
      return <SocialHandles content={content} />
    case `${dynamicParam}_Sections_Sections_Overview`:
      return <Overview content={content} />
    case `${dynamicParam}_Sections_Sections_StatsOverview`:
      return <StatsOverview content={content} />
    case `${dynamicParam}_Sections_Sections_BoxQuote`:
      return <BoxQuote content={content} />
    case `${dynamicParam}_Sections_Sections_OverviewComponents`:
      return <OverviewController content={content} />;
      case `${dynamicParam}_Sections_Sections_ReviewCta`:
        return <ReviewCTA content={content} />
    case `${dynamicParam}_Sections_Sections_MasonryGallery`:
      return <MasonryGallery content={content} />
      case `${dynamicParam}_Sections_Sections_Card`:
        return <Card content={content} />

    default:
      return ""
  }
}
